export default {
	sec_01: {
		title: {
			one: 'JP WORLD PAY을 ',
			two: '사용하면',
			three: '보상이 추가됩니다.',
		},
		desc: {
			one: '거래, 캐시백 제안 및 프로모션 코드를 쌓아',
			two: '돈을 절약하고 최고의 매장과 좋아하는 브랜드에서',
			three: '보상을 받으세요.',
		},
		btn: {
			one: '회원가입하기',
			two: '앱 다운로드',
		},
	},
	sec_09: {
		title: {
			one: '나에게 맞는',
			two: '암호화폐로 거래',
		},
		one: {
			desc: {
				one: '우리는 당신이 쇼핑하고 구매하는 장소를 기반으로 당신이',
				two: '좋아 할 것으로 생각되는 거래, 제품 및 상점을 선 보일 것이며',
				three:
					'즐겨찾는 상점 또한 지속적으로 늘려나가며 업데이트 할 것을 약속합니다.',
			},
		},
	},
	sec_03: {
		one: {
			title: {
				one: 'Maximize your rewards',
				two: '보상 극대화',
			},
			desc: {
				one: '거래, 캐시백 제안 및 프로모션 코드를 결합하면',
				two: '더 많은 비용을 절약 할 수 있습니다.',
				three: '결제 시 프로모션 코드를 찾고 적용하는데 도움을 드리겠습니다.',
				four: 'JP WORLD PAY 카드가 보상을 제공합니까?',
				five: '구매에 대해 체크아웃하고 보상을 받을 때 사용하십시오.',
			},
			btn: '쇼핑 시작',
		},
		two: {
			title: {
				one: '보안 체크아웃',
			},
			desc: {
				one: 'JP WORLD PAY로 안전하게 결제 할 때 수백만개의',
				two: '글로벌 소매업체에서 거래 및 캐시백 제안을 활용하세요.',
				three: '귀하의 정보는 암호화 되어 있으며 귀하의 허락 없이',
				four: '판매하거나 공유하지 않습니다.',
			},
			btn: '귀하를 보호 할 수 있는 방법 알아보기',
		},
	},
	common: {
		coming_soon: '준비중 입니다.',
	},
};
